import React, { useEffect } from "react";
import { panel } from "../../json/panel";
import { Link } from "react-router-dom";

const Servicios = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container servicios-container">
      <div className='row'>
            <div className='col_12'>
                <div className='servicios_title'>
                    <h1>Panel de Control</h1>
                </div>
            </div>
        </div>
      <div className="row">        
        {panel.map((item, index) => (
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h6 className="card-title"> {item.nombre} </h6>
                <Link to={"../"+item.nombre}>
                <button className="btn btn-secondary float-end">
                  Nuevo Registro
                </button>
              </Link>
                <div className="btn_agenda"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <hr className="hr-gob" />
    </div>
  );
};

export default Servicios;
